import React from 'react';
import { Box, Typography } from '@mui/material';

interface CapabilityCardProps {
  icon: string;
  title: string;
  description?: string;
  children?: React.ReactNode;
  onClick?: () => void;
  contentId?: string;
  action?: string;
  sx?: any;
}

const CapabilityCard: React.FC<CapabilityCardProps> = ({
  icon,
  title,
  description,
  children,
  onClick,
  contentId,
  action,
  sx,
}) => {
  return (
    <Box
      onClick={onClick}
      data-content-id={contentId}
      data-action={action}
      sx={{
        background: 'var(--white)',
        border: '1px solid #e0e7ff',
        borderRadius: '8px',
        padding: '20px',
        margin: '16px 0',
        boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
        transition: 'all 0.3s ease',
        cursor: (onClick || contentId || action) ? 'pointer' : 'default',
        '&:hover': (onClick || contentId || action) ? {
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
          transform: 'translateY(-2px)',
        } : {},
        ...sx,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', mb: description || children ? 1 : 0 }}>
        <Typography
          component="span"
          sx={{
            fontSize: '24px',
            marginRight: '12px',
            color: 'var(--primary-blue)',
          }}
        >
          {icon}
        </Typography>
        <Typography
          sx={{
            fontFamily: 'var(--font-heading)',
            fontSize: '18px',
            fontWeight: 600,
            color: 'var(--primary-blue)',
          }}
        >
          {title}
        </Typography>
      </Box>
      {description && (
        <Typography
          sx={{
            fontFamily: 'var(--font-body)',
            fontSize: '14px',
            color: 'var(--dark-gray)',
            lineHeight: 1.5,
          }}
        >
          {description}
        </Typography>
      )}
      {children}
    </Box>
  );
};

export default CapabilityCard;

